<template>
  <Modal v-model="visible" :title="formData.id ? '编辑' : '新增'" width="500" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Form v-if="visible" ref="form" :model="formData" class="page-form" :label-width="50" v-loading="loading">
      <FormItem prop="img" label="图片" :rules="$units.formRule.required('请上传')" class="full">
        <uploadNew v-model="formData.imgUrl" @change="imgUpload" @remove="removeUploadImg" :disabled="formData.isSys == 1"></uploadNew>
      </FormItem>
      <FormItem prop="systemType" label="平台" :rules="$units.formRule.required('请选择')" class="full">
        <Select v-model="formData.systemType" filterable @on-change="selectSystem">
          <Option value="1">iOS</Option>
          <Option value="2">Android</Option>
        </Select>
      </FormItem>
      <FormItem prop="imgSize" label="尺寸" :rules="$units.formRule.required('请选择')" class="full">
        <Select v-model="formData.imgSize" filterable transfer>
          <Option :value="item.value" v-for="(item, index) in sizeList" :key="index">{{ item.value }}</Option>
        </Select>
      </FormItem>
      <FormItem label="有效期" class="full">
        <DatePicker
          :clearable="true"
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          :value="formData.validDate"
          @on-change="formData.validDate = $event"
          format="yyyy-MM-dd"
          placeholder="不填立即生效"
        >
        </DatePicker>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save">确认</Button>
    </div>
  </Modal>
</template>

<script>
import uploadNew from '@/components/commons/uploadNew';
export default {
  components: { uploadNew },
  props: ['stopTime', 'getTabList'],
  data() {
    return {
      tabId: '1',
      visible: false,
      loading: false,
      formData: {},
      sizeList: []
    };
  },
  methods: {
    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        let data = {
          systemType: formData.systemType,
          imgUrl: formData.img,
          retentionTime: this.stopTime,
          imgSize: formData.imgSize
        };
        if (formData.validDate && formData.validDate[0]) {
          data.effectTimeStart = formData.validDate[0];
          data.effectTimeEnd = formData.validDate[1];
        }
        if (this.formData.id) {
          data.id = this.formData.id;
        }
        this.$http({
          url: this.formData.id ? '/buz/startupPageConfig/edit' : '/buz/startupPageConfig/add',
          type: 'POST',
          data,
          apiPermissionCode: 'systemSet_10_1'
        }).then(res => {
          this.visible = false;
          this.$notice.success(formData.id ? '修改成功' : '新增成功');
          this.getTabList();
        });
      });
    },
    async open(data = {}) {
      data = JSON.parse(JSON.stringify(data));
      if (data.id) {
        this.selectSystem(data.systemType);
        data.img = data.imgUrl.path;
        if (data.effectTimeStart && data.effectTimeEnd) {
          data.validDate = [data.effectTimeStart, data.effectTimeEnd];
        }else{
          data.validDate = [];
        }
        this.formData = data;
      } else {
        this.formData = {
          imgUrl: []
        };
      }
      this.visible = true;
    },
    querySize(code) {
      this.$http({
        url: '/system/dic/read/dicList',
        type: 'POST',
        data: {
          code
        }
      }).then(res => {
        this.sizeList = res.data;
      });
    },
    selectSystem(value) {
      if (value == '1') {
        this.querySize('IOS_SIZE');
      } else {
        this.querySize('ANDROID_SIZE');
      }
    },
    // 上传图片
    imgUpload() {
      if (this.formData.imgUrl && this.formData.imgUrl[0]) {
        this.$set(this.formData, 'img', this.formData.imgUrl[0].path);
      }
      this.$refs.form.validateField('img');
    },
    // 删除图片
    removeUploadImg(index) {
      this.$set(this.formData, 'img', '');
    }
  }
};
</script>
<style lang="scss" scoped>
</style>